import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CmsService } from 'src/app/services/cms.service';

@Component({
  selector: 'app-media-modal',
  templateUrl: './media-modal.component.html',
  styleUrls: ['./media-modal.component.scss']
})
export class MediaModalComponent implements OnInit {
  @Input() public mediaPath;
  public mediaSelect: File[] = [];

  constructor(public modal: NgbActiveModal, public cms: CmsService) {}

  public ngOnInit() {}
}
